/*
* Helper functions
*/

export function donwloadFile(data, file_name){
	var fileDownload = require('js-file-download');
    fileDownload(data, file_name);
}


// WEBPACK FOOTER //
// ./src/helpers/helper.js